// ============================================================
// Payroll — Access Rights
// Range: 5001–5099
// ============================================================

export const PAYROLL_ACCESS_RIGHTS = {

  //#region DASHBOARDS
  PAYFLOW_DASHBOARD:                                    5001,
  //#endregion

};